module.exports = __webpack_public_path__ + "img/d200912-1.96fe44d8.jpg";